import React from 'react';
import './TopRowButtons.css';
import {connect} from "react-redux";

const topRowButtons = props => {
	let barWidth = '', firstBlockButtonClass = '', secondBlockButtonClass = '', thirdBlockButtonClass = '', rotateFirstBlockMask = false, rotateSecondBlockMask = false, rotateThirdBlockMask = false;
	let introBlockSelected = false, bodyBlocksSelected = 0, outroBlockSelected = false;
	[...props.selectedBlocks].map(block => {
		if (block.type === 'intro') introBlockSelected = true;
		if (block.type === 'body') bodyBlocksSelected = bodyBlocksSelected + 1;
		if (block.type === 'outro') outroBlockSelected = true;
		return null;    // or React will bitch about missing return statement
	});

	if (bodyBlocksSelected >= 1 && bodyBlocksSelected <= 3) firstBlockButtonClass = `respective-block-selected ${props.currentApp}`;
	if (bodyBlocksSelected >= 2 && bodyBlocksSelected <= 3) secondBlockButtonClass = `respective-block-selected ${props.currentApp}`;
	if (bodyBlocksSelected === 3) thirdBlockButtonClass = `respective-block-selected ${props.currentApp}`;

	if (introBlockSelected) {
		if (bodyBlocksSelected === 0) barWidth = 'set-width-170px';
		if (bodyBlocksSelected === 1) {
			barWidth = 'set-width-300px';
			rotateFirstBlockMask = true;
		}
		if (bodyBlocksSelected === 2) {
			barWidth = 'set-width-400px';
			rotateFirstBlockMask = true;
			rotateSecondBlockMask = true;
		}
		if (bodyBlocksSelected === 3) {
			barWidth = 'set-width-520px';
			rotateFirstBlockMask = true;
			rotateSecondBlockMask = true;
			rotateThirdBlockMask = true;
		}
	}

	const blockButtons = [
		<li key='blockButton-1'>
			<div className='button-container'>
				<div className={`half-circle ${props.currentApp}`} />
				<div className={`masking-container-top ${rotateFirstBlockMask ? 'rotate-mask' : ''}`} />
				<div className='masking-container-bottom' />
				<span className={firstBlockButtonClass}>1</span>
			</div>
		</li>,
		<li key='blockButton-2'>
			<div className='button-container'>
				<div className={`half-circle ${props.currentApp}`} />
				<div className={`masking-container-top`} />
				<div className={`masking-container-bottom ${rotateSecondBlockMask ? 'rotate-mask-alternate' : ''}`} />
				<span className={secondBlockButtonClass}>2</span>
			</div>
		</li>,
		<li key='blockButton-3'>
			<div className='button-container'>
				<div className={`half-circle ${props.currentApp}`} />
				<div className={`masking-container-top ${rotateThirdBlockMask ? 'rotate-mask' : ''}`} />
				<div className='masking-container-bottom' />
				<span className={thirdBlockButtonClass}>3</span>
			</div>
		</li>
	];

	return (
		props.currentApp === 'app-3' ?
		null :
		(
			<div className="top-row-main">
				<div className={`top-row-bar ${props.currentApp} ${barWidth}`} />
				<div className="top-row intro-button"><span className={`${introBlockSelected ? `respective-block-selected ${props.currentApp}` : ''}`} >intro</span></div>
				<ul className="count top-row">
					{blockButtons}
				</ul>
				<div className="top-row outro-button"><span className={`${outroBlockSelected ? `respective-block-selected ${props.currentApp}` : ''}`} >outro</span></div>
			</div>
		)
	)
};

const mapStateToProps = state => ({
	currentApp: state.appReducer.currentApp
});

export default connect(mapStateToProps)(topRowButtons);